"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _scenePreview = require("./scenePreview");
Object.keys(_scenePreview).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _scenePreview[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _scenePreview[key];
    }
  });
});